module.exports = __webpack_public_path__ + "img/32776-085.a3ab38ae.jpg";